var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAnalise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,20a9.972,9.972,0,0,1-3.737-.725,2.507,2.507,0,1,1,.728-1.861,8.119,8.119,0,0,0,6.13-.041,7.981,7.981,0,0,0,4.252-4.251A7.985,7.985,0,0,0,18,10h2A9.977,9.977,0,0,1,10,20ZM2,10H0A9.979,9.979,0,0,1,6.1.784,10.134,10.134,0,0,1,13.737.725,2.5,2.5,0,1,1,15.5,5a2.488,2.488,0,0,1-2.491-2.415,8.119,8.119,0,0,0-6.13.041A7.981,7.981,0,0,0,2.627,6.878,7.994,7.994,0,0,0,2,10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.538,9.076A4.538,4.538,0,1,1,9.076,4.538,4.543,4.543,0,0,1,4.538,9.076ZM4.538,2A2.538,2.538,0,1,0,7.076,4.538,2.541,2.541,0,0,0,4.538,2Z",
    transform: "translate(5.463 5.463)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAnalise);
export default __webpack_public_path__ + "static/media/ico-analise.de9765d85b69d6d60e865c6b65e3d90d.svg";
export { ForwardRef as ReactComponent };